import Breadcrumb from "components/Common/Breadcrumb"
import { toast, ToastContainer } from "react-toastify"
import React, { useEffect, useMemo, useState } from "react"
import Loader from "components/Common/Loader"

import { Button } from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import { getCountries, getVirtualUser } from "services/ApiService"
import VirtualUserDataTable from "components/Common/VirtualUserDataTable"
import LeaderBoardUserDataTable from "components/Common/LeaderBoardUserDataTable"
import { base_url } from "utils/APIUrls"

function Leaderboard() {
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState([])
  const [country, setCountry] = useState([])

  var getUser = () => {
    getVirtualUser().then(res => {
      setData(res.data)
      setIsLoading(false)
      console.log("Virtual USer.....", res.data)
    })
  }

  useEffect(() => {
    getUser()
    fetchCountryData()
  }, [])

  const fetchCountryData = () => {
    getCountries().then(res => {
      setCountry(res.data)
    })
  }

  const columns = useMemo(
    () => [
      {
        Header: "First Name",
        accessor: "firstname",
        headerStyle: { textAlign: "center" },
        disableSortBy: true,
      },
      {
        Header: "Last Name",
        accessor: "lastname",
        headerStyle: { textAlign: "center" },
        disableSortBy: true,
      },
      {
        Header: "Email",
        accessor: "email",
        headerStyle: { textAlign: "center" },
        disableSortBy: true,
      },
      {
        Header: "Country Name",
        accessor: "countryName",
        headerStyle: { textAlign: "center" },
        disableSortBy: true,
      },
      {
        Header: "Tests",
        accessor: "noOfEvents",
        headerStyle: { textAlign: "center" },
        disableSortBy: true,
      },
      {
        Header: "Hits",
        accessor: "noOfHits",
        headerStyle: { textAlign: "center" },
        disableSortBy: true,
      },
      {
        Header: "Scores",
        accessor: "cumulativeScore",
        headerStyle: { textAlign: "center" },
        disableSortBy: true,
      },
    ],
    []
  )

  var handleAddUser = () => {
    window.location.href = "/add-leader-board"
  }

  return (
    <div className="page-content">
      <Breadcrumb title="Dashboard" breadcrumbItem="Leaderboard" />

      <ToastContainer />

      <div className="container-fluid">
        {/* Add Button to open the Add Category modal */}
        <div className="d-flex flex-row-reverse mb-4">
          <Button
            className="badge bg-primary d-inline-block font-size-13 text-center border-0"
            style={{
              padding: "12px 19px",
              minWidth: "100px",
              borderRadius: "17px",
            }}
            onClick={handleAddUser}
          >
            + Add User
          </Button>
        </div>

        {/* Conditionally render the table based on the active tab */}
      </div>

      <LeaderBoardUserDataTable
        apiURL={`${base_url}/admin/v1/user/leaderboard-get-users`}
        idName="Leaderboard"
        countries={country}
      />
    </div>
  )
}

export default Leaderboard
